/* eslint-disable @nx/enforce-module-boundaries */
// ONLY EXPORT ENUMS
export { CampaignType, Co2Class, DealerType, ModelCategory } from '@hyundai/hygraph-schema';
